// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__exMz3 {
  display: flex;
  align-items: center;
  border-radius: 20px;
  padding: 3px 6px;
  border: 1px solid #dce3e4;
  background: #f8f8ff;
}
.styles_wrapper__exMz3 svg {
  max-height: 16px;
  width: 16px;
}
.styles_wrapper__exMz3 .styles_title__XY3-X {
  display: contents;
  font-family: "Open Sans";
  font-style: normal;
  font-size: 14px;
  line-height: 140%;
  margin-left: -25px;
  color: #333333;
}

.styles_active__veaoj {
  padding: 6px 16px 6px 8px;
  gap: 6px;
  background: #ffffff;
  border: 1px solid rgb(178, 184, 191);
  border-radius: 40px;
  cursor: pointer;
  outline: none;
}
.styles_active__veaoj svg {
  stroke: rgb(178, 184, 191);
  max-height: 17px;
}
.styles_active__veaoj .styles_title__XY3-X {
  font-family: "Open Sans Semi Bold";
  font-size: 14px;
  line-height: 116%;
}

.styles_green__N-ItL {
  border: 1px solid #c8e3b7;
  background-color: #f6fff8;
}
.styles_green__N-ItL svg {
  stroke: rgb(90, 175, 38);
}
.styles_green__N-ItL.styles_active__veaoj {
  border-color: rgb(90, 175, 38);
  background-color: #ffffff;
}

.styles_red__rkmnX {
  border: 1px solid #f2cccc;
  background-color: #fdf2f2;
}
.styles_red__rkmnX svg {
  stroke: rgb(223, 89, 89);
}
.styles_red__rkmnX.styles_active__veaoj {
  border-color: rgb(223, 89, 89);
  background-color: #ffffff;
}

.styles_option__eF9e0 {
  border-color: transparent;
  background: transparent;
  width: 100%;
  padding: 9px 11px;
}
.styles_option__eF9e0 > div:first-child {
  margin-right: 8px;
}

.styles_select__8c2Jp .styles_description__-8Zqp {
  display: flex;
  flex-direction: column;
  text-align: left;
}
.styles_select__8c2Jp .styles_description__-8Zqp span {
  font-size: 12px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #919ca7;
}`, "",{"version":3,"sources":["webpack://./src/components/ApplicationStatus/styles.module.scss"],"names":[],"mappings":"AAIA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AAHF;AAKE;EACE,gBAAA;EACA,WAAA;AAHJ;AAME;EACE,iBAAA;EACA,wBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAJJ;;AAQA;EACE,yBAAA;EACA,QAAA;EACA,mBAAA;EACA,oCAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;AALF;AAOE;EACE,0BAtCG;EAuCH,gBAAA;AALJ;AAQE;EACE,kCAAA;EACA,eAAA;EACA,iBAAA;AANJ;;AAUA;EACE,yBAAA;EACA,yBAAA;AAPF;AASE;EACE,wBArDI;AA8CR;AAUE;EACE,8BAzDI;EA0DJ,yBAAA;AARJ;;AAYA;EACE,yBAAA;EACA,yBAAA;AATF;AAWE;EACE,wBAlEE;AAyDN;AAYE;EACE,8BAtEE;EAuEF,yBAAA;AAVJ;;AAcA;EACE,yBAAA;EACA,uBAAA;EACA,WAAA;EACA,iBAAA;AAXF;AAaE;EACE,iBAAA;AAXJ;;AAgBE;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AAbJ;AAeI;EACE,eAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AAbN","sourcesContent":["$gray: rgba(178, 184, 191, 1);\n$green: rgba(90, 175, 38, 1);\n$red: rgba(223, 89, 89, 1);\n\n.wrapper {\n  display: flex;\n  align-items: center;\n  border-radius: 20px;\n  padding: 3px 6px;\n  border: 1px solid #dce3e4;\n  background: #f8f8ff;\n\n  svg {\n    max-height: 16px;\n    width: 16px;\n  }\n\n  .title {\n    display: contents;\n    font-family: 'Open Sans';\n    font-style: normal;\n    font-size: 14px;\n    line-height: 140%;\n    margin-left: -25px;\n    color: #333333;\n  }\n}\n\n.active {\n  padding: 6px 16px 6px 8px;\n  gap: 6px;\n  background: #ffffff;\n  border: 1px solid $gray;\n  border-radius: 40px;\n  cursor: pointer;\n  outline: none;\n\n  svg {\n    stroke: $gray;\n    max-height: 17px;\n  }\n\n  .title {\n    font-family: 'Open Sans Semi Bold';\n    font-size: 14px;\n    line-height: 116%;\n  }\n}\n\n.green {\n  border: 1px solid #c8e3b7;\n  background-color: #f6fff8;\n\n  svg {\n    stroke: $green;\n  }\n\n  &.active {\n    border-color: $green;\n    background-color: #ffffff;\n  }\n}\n\n.red {\n  border: 1px solid #f2cccc;\n  background-color: #fdf2f2;\n\n  svg {\n    stroke: $red;\n  }\n\n  &.active {\n    border-color: $red;\n    background-color: #ffffff;\n  }\n}\n\n.option {\n  border-color: transparent;\n  background: transparent;\n  width: 100%;\n  padding: 9px 11px;\n\n  > div:first-child {\n    margin-right: 8px;\n  }\n}\n\n.select {\n  .description {\n    display: flex;\n    flex-direction: column;\n    text-align: left;\n\n    span {\n      font-size: 12px;\n      letter-spacing: 0.05em;\n      text-transform: uppercase;\n      color: #919ca7;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__exMz3`,
	"title": `styles_title__XY3-X`,
	"active": `styles_active__veaoj`,
	"green": `styles_green__N-ItL`,
	"red": `styles_red__rkmnX`,
	"option": `styles_option__eF9e0`,
	"select": `styles_select__8c2Jp`,
	"description": `styles_description__-8Zqp`
};
export default ___CSS_LOADER_EXPORT___;
